const drawerWidth = 300;
export const styles = theme => ({
  body: {
    fontFamily: "Roboto"
  },
  root: {
    display: 'flex',
  },
  // toolbar: {
  //   paddingRight: 24, // keep right padding when drawer closed
  // },
  toolbarIcon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  toolbar: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center"
  },
  appBar: {
    backgroundColor: "white",
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  chartPanel: {
    display: 'flex',
  },
  button: {
    backgroundColor: "red",
  },
  menuButton: {
    color: "#424242",
    marginLeft: 12,
    marginRight: 12,
  },
  menuButtonHidden: {
    display: 'none',
  },
  title: {
    flexGrow: 1,
  },

  drawerHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    paddingLeft: "10px"
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 9,
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    marginTop: "60px",
    flexGrow: 1,
    padding: theme.spacing.unit * 3,
    height: '90vh',
    overflow: 'auto',
  },
  panelInfo: {
    display: "flex",
    width: "90%",
    margin: "auto",
    justifyContent: "space-between",
    alignContent: "center",
    alignItems: "center",
    marginBottom: "10px",
    marginTop: "-8px"
  },
  sortMenuItem: {
    fontSize: "0.875rem"
  },
  refreshButton: {
    marginLeft: "15px"
  },
  h2: {
    fontSize: '18px',
  },
  chartContainer: {
    marginLeft: -22,

  },
  tableContainer: {
    height: 320,
  },
  h5: {
    marginBottom: theme.spacing.unit * 2,
  },
  logsTitle: {
    fontSize: '18px',
    paddingTop: "20px",
    paddingBottom: "20px",
  },
  chartTitle: {
    display: "flex",
    justifyContent: "space-between"
  },
  loading: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%"
  },
  logout: {
    marginRight: "12px",
    color: "#424242"
  },
  titleContainer: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    alignItems: "center",
    margin: "auto 0",
    height: "50px"
  },
  headerTitle: {
    height: "90%",
    width: "auto",
    margin: "auto 0"
  },
  headerTitleMobile: {
    margin: "auto 0",
    width: "100%",
    height: "auto"
  }
});



// WEBPACK FOOTER //
// ./src/styles/dashboard-styles.js